import { defineComponent as _defineComponent } from 'vue';
import sanitizeHtml from 'sanitize-html';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzRichText',
  props: {
    content: null
  },
  setup: function setup(__props) {
    var props = __props;
    var sanitizedContent = computed(function () {
      return sanitizeHtml(props.content);
    });
    return {
      __sfc: true,
      props: props,
      sanitizedContent: sanitizedContent
    };
  }
});